export default "__VITE_ASSET__WHXj02mr__"